import QS from 'qs'
import Jax from '@bxs/jax'
import { parseHostname } from '@bxs/jax/getRelativeOrigin'
import Cookie from 'js-cookie'

export const { isApp, appType, appVersion, isAndroid, isIos, isBxsApp, isBaoXiaoZhuApp, isBrokerApp, isYjjApp, isToBApp, isRongYiBaoApp, isWeChat, appScheme } = Jax.parseUaString()

const userAgent = window && window.navigator && window.navigator.userAgent || ''
const hostname = window && window.location && window.location.hostname || ''

export const IS_PRODUCT_ENV = hostname.search(/(winbaoxian|ai-baoxiaozhu)\.com/) !== -1
export const IS_DEVELOP_ENV = hostname.search(/(winbaoxian|ai-baoxiaozhu)\.cn/) !== -1
export const IS_LOCALHOST_ENV = hostname.search(/localhost|192\.168|127\.0\.0\.1|dev\.winbaoxian\.cn/) !== -1
export const IS_UAT_ENV = hostname.includes('pbf-uat.')
export const IS_ENABLE_DEBUG = !IS_PRODUCT_ENV
if (IS_ENABLE_DEBUG) {
  console.error('非线上环境，默认开启调试模式')
}

const topDomain = IS_PRODUCT_ENV ? 'com' : 'cn'
export const isBxzDomain = hostname.includes('ai-baoxiaozhu')
const secondDomain = isBxzDomain ? 'ai-baoxiaozhu' : 'winbaoxian'
export const MAIN_DOMAIN = `${secondDomain}.${topDomain}`

export const BXS_APPID = 518001
export const BROKER_APPID = 518002
export const GAOKE_APPID = 518003
export const NUOYA_APPID = 81800000001
export const BAOXIAOZHU_SINGLE_APPID = 918001
export const APPID = getAppId()
export function getAppId () {
  const urlQueryAppId = getUrlParams().appId || getUrlParams().appid
  if (urlQueryAppId) {
    return urlQueryAppId
  }
  const appChannel = getAppChannel()
  if (appChannel) {
    let appId = ''
    if (appChannel === 'BXS') {
      appId = BXS_APPID
    }
    if (appChannel === 'BROKER') {
      appId = BROKER_APPID
    }
    if (appChannel === 'WECHAT_GAOKE') {
      appId = GAOKE_APPID
    }
    if (appChannel === 'NUOYA') {
      appId = NUOYA_APPID
    }
    if (['BaoXiaoZhu', 'WECHAT_BXZ', 'WXMP_BXZ', 'H5_BXZ'].includes(appChannel)) {
      appId = Cookie.get('appId')
    }
    return appId
  }
  return ''
}

// export const WYJHS_WX_PUBLIC_APPID  = 'wxe2a04a49c02b1d5d' // 微易计划书公众号
// export const WYBXGJ_WX_PUBLIC_APPID = 'wxbbbc0282a87ff36b' // 微易保险管家公众号
// export const WYJF_WX_PUBLIC_APPID   = 'wxf0fc23c01bde1d3f' // 微易积分公众号（测试）
export const WX_AUTH_PUBLIC_APPID = parseHostname(location.hostname).wxAppId  // 用于微信授权的公众号

export const WXMP_WYJHS_APPID = 'wxcfb8e9f01feb8ced' // 微易计划书微信小程序
export const WXMP_BXZJHS_APPID = 'wx7cb203f36e523c11' // 保小助计划书微信小程序
export const WXMP_APPID = isBxzDomain ? WXMP_BXZJHS_APPID : WXMP_WYJHS_APPID

export const APP_HOSTNAME = `https://app.${MAIN_DOMAIN}`
export const CONTENT_HOSTNAME = `https://content.${MAIN_DOMAIN}`
export const CLIENT_HOSTNAME = `https://client.${MAIN_DOMAIN}`
export const TOOL_API_HOSTNAME = `https://tool-api.${MAIN_DOMAIN}`
export const INTERACTION_HOSTNAME = `https://interaction-api.${MAIN_DOMAIN}`
export const PBF_HOSTNAME = `https://pbf.${MAIN_DOMAIN}`
export const PBF_UAT_HOSTNAME = `https://pbf${IS_UAT_ENV ? '-uat' : ''}.${MAIN_DOMAIN}`
export const POLICY_INSPECTION_HOSTNAME = `https://policy-inspection${IS_UAT_ENV ? '-uat' : ''}.${MAIN_DOMAIN}`
export const BROKER_HOSTNAME = `https://broker-2a.wyins.net${IS_PRODUCT_ENV ? '' : '.cn'}`
export const PLANBOOK_API_HOSTNAME = `https://bxs-planbook-api${IS_UAT_ENV ? '-uat' : ''}.${MAIN_DOMAIN}`
export const CRM_HOSTNAME = `https://wechat-crm.${MAIN_DOMAIN}`
export const WX_HOSTNAME = `https://wx.winbaoxian.${IS_PRODUCT_ENV ? 'com' : 'cn'}`
export const WXMEMBER_API_HOSTNAME = `https://wxmember-api.${MAIN_DOMAIN}`
export const MANAGEMENT_BXZ_HOSTNAME = `https://management.ai-baoxiaozhu.${IS_PRODUCT_ENV ? 'com' : 'cn'}`

export const IS_APP_PLATFORM = (isApp || ['WXMP', 'WXMP_BXZ', 'WECHAT_GAOKE', 'WECHAT_GAOKE_CUSTOMER', 'WECHAT_BXS', 'WECHAT_BXZ', 'WECHAT_BXZ'].includes(getAppChannel())) && !getUrlParams().shareFrom

export const URL_PARAM = getUrlParams()
export function getUrlParams (url) {
  const _url = url || location.search || ''
  const _searchStr = _url.split('?')[1]
  return _searchStr ? QS.parse(_searchStr) : {}
}

export const APP_CHANNEL = getAppChannel()
// APP:
// - BXS-保险师
// - BaoXiaoZhu-保小助
// - BROKER-经纪人
// - YJJ-易经经（上职场）
// - TOB-toB
// - NUOYA-诺亚（荣易保）
// 其他平台:
// - WXMP-微信小程序
// - WXMP_BXZ-保小助微信小程序
// - WECHAT_BXS-微易计划书公众号
// - WECHAT_BXZ-保小助公众号
// - WECHAT_GAOKE-微信公众号（高客）
// - WECHAT_GAOKE_CUSTOMER-微信公众号（高客客户）
// - WECHAT-微信
// - H5_BXZ-保小助H5
// - H5-其他渠道（如：浏览器）
function getAppChannel() {
  const _shareFrom = getUrlParams().shareFrom
  const _appId = getUrlParams().appId || getUrlParams().appid || Cookie.get('appId')
  const _pageForm = getUrlParams().page_form
  const _pageCrm = getUrlParams().page_crm
  const _jumpSource = getUrlParams().jumpSource
  if (_jumpSource === 'WECHAT_GAOKE' || _pageForm === 'crm') {
    return 'WECHAT_GAOKE'
  }
  if (_jumpSource === 'WECHAT_GAOKE_CUSTOMER' || (_pageForm === 'crm' && _pageCrm === 'customer')) {
    return 'WECHAT_GAOKE_CUSTOMER'
  }
  if (!_shareFrom) {
    if (isBxsApp || isBaoXiaoZhuApp) {
      return appType
    }
    if (isRongYiBaoApp) {
      return 'NUOYA'
    }
    if (isBrokerApp) {
      return 'BROKER'
    }
    if (isYjjApp) {
      return 'YJJ'
    }
    if (isToBApp) {
      return 'TOB'
    }
  }
  // https://developers.weixin.qq.com/community/develop/doc/00022e37c78b802f186750b5751000
  if ((userAgent.match(/micromessenger/i) && userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram') {
    if (_appId && _appId.startsWith('918')) {
      return 'WXMP_BXZ'
    }
    return 'WXMP'
  }
  if (isWeChat) {
    if (!_shareFrom) {
      if (_appId && _appId.startsWith('918')) {
        return 'WECHAT_BXZ'
      }
      if (_appId === String(GAOKE_APPID)) {
        return 'WECHAT_GAOKE'
      }
      if (_appId === String(BXS_APPID) || !_appId) {
        return 'WECHAT_BXS'
      }
    }
    return 'WECHAT'
  }
  if (!_shareFrom && isBxzDomain) {
    return 'H5_BXZ'
  }
  return 'H5'
}

export const isBaoXiaoZhuPlatform = ['BaoXiaoZhu', 'WXMP_BXZ', 'WECHAT_BXZ', 'H5_BXZ'].includes(APP_CHANNEL);
export const isBaoXiaoZhuSingle = isBaoXiaoZhuPlatform && ( APPID === String(BAOXIAOZHU_SINGLE_APPID) || Cookie.get('appId') === String(BAOXIAOZHU_SINGLE_APPID));
export const isBaoXiaoZhuTenant = isBaoXiaoZhuPlatform && String(APPID) !== String(BAOXIAOZHU_SINGLE_APPID)
